import {
  ONEC_CAPABILITY_HINTS,
  ONEC_CAPABILITY_LABELS,
  ONEC_KIND,
  ONEC_TITLE,
  emptyOneCSettings,
  validateOneCSettings,
} from './model/settings'
import { OneCConnectionForm } from './ui/OneCConnectionForm'

/**
 * Форма подключения 1С для реестра Platform. Объект той же формы, что
 * `ConnectionFormExtension` пакета `platform-ui`: пакеты друг друга не
 * импортируют, совместимость проверяет компилятор при регистрации в
 * `apps/web/src/composition/connectionForms.ts`.
 */
export const onecConnectionForm = {
  kind: ONEC_KIND,
  title: ONEC_TITLE,
  /** Метка вида на вкладках разделов (UI-SECTIONS). */
  shortTitle: '1С',
  /** Слово вида на плитке источника (UI-RMK-FLOW 3.4). */
  sourceNoun: 'База 1С',
  /** Цвет вида — палитра источника ui-kit, та же, что у рамки окон пакета. */
  tone: 'onec',
  /** Строка на плитке окна «Добавить источник». */
  summary: 'База 1С:Предприятие: товары, цены, поставки и склад.',
  capabilityLabels: ONEC_CAPABILITY_LABELS,
  capabilityHints: ONEC_CAPABILITY_HINTS,
  // Права и модули вида — из манифеста с сервера; пакет вида даёт слова. Один модуль `main` называется как сам вид.
  secret: {
    label: 'Пароль пользователя 1С',
    hint: 'Хранится на сервере зашифрованным и сюда не возвращается.',
    requiredOnCreate: true,
  },
  emptySettings: emptyOneCSettings,
  validate: validateOneCSettings,
  Form: OneCConnectionForm,
} as const
